import React, { useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { loadStripe } from '@stripe/stripe-js';
import './Membership.css';

const stripePromise = loadStripe('YOUR_PUBLISHABLE_KEY');

function Membership({ onPayButtonClick }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [selectedStates, setSelectedStates] = useState([]);
  const [showPayment, setShowPayment] = useState(false);
  const [signInEmail, setSignInEmail] = useState('');
  const [signInPassword, setSignInPassword] = useState('');

  const states = ['Arizona', 'California', 'Florida', 'Georgia', 'Illinois', 'Nevada', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Pennsylvania', 'South Carolina', 'Tennessee', 'Texas', 'Virginia'].map(state => ({ label: state, value: state }));

  const handleRegisterSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post('https://example.com/api/register', {
        name,
        email,
        password,
        selectedStates: selectedStates.map(state => state.value),
      });
      console.log(response.data);
      onPayButtonClick();
    } catch (error) {
      console.error(error);
    }
  };

  const handleJoinNow = () => {
    setShowPayment(true);
  };

  const handlePaymentSuccess = () => {
    setShowPayment(false);
  };

  const handleSignInSubmit = (event) => {
    event.preventDefault();
    // Add your sign-in logic here
    console.log('Email:', signInEmail);
    console.log('Password:', signInPassword);
  };

  return (
    <div className="container">
      <h1>Membership Info</h1>
      <p>Thank you for visiting the membership page. Here we'll give you an easy breaking down about how to register.</p>
      <p>Here are the states that we provide data for:</p>
      <ol>
        {states.map(state => <li key={state.value}>{state.label}</li>)}
      </ol>
      <p>Data costs: we offer a very basic monthly fee of $10.00</p>
      <p>Broken down you're only paying 33¢'s a day.</p>
      <p>After payment via credit card, you'll be sent your password to unlock the system so you can gain access to the state data you want to play in.</p>
      <p>Understanding the data is simple and there aren't 100's of variables you have to interpret on your own like many other systems on the web.</p>
      <p>On the state data page we provide players with the highest statistical value based on our algorithms....the format is way easier and with our system there is nothing to download to clog your computer.</p>
      <p>We provide the time-consuming data crunching and you reap the rewards.</p>
      <h2>Register For Free</h2>
      <form className="form" onSubmit={handleRegisterSubmit}>
        <label className="label">
          Name:
          <input className="input" type="text" value={name} onChange={e => setName(e.target.value)} />
        </label>
        <label className="label">
          Email:
          <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)} />
        </label>
        <label className="label">
          Password:
          <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)} />
        </label>
        <label className="label">
          Select Which States You Play Pick 3:
          <Select 
            options={states}
            isMulti
            onChange={selectedOptions => setSelectedStates(selectedOptions)}
          />
        </label>
        <input className="input" type="submit" value="Register" />
      </form>

      {!showPayment && (
        <>
          <button className="button" onClick={handleJoinNow}>Become a Member!</button>
          <h2>Sign In</h2>
          <form className="form" onSubmit={handleSignInSubmit}>
            <label className="label">
              Email:
              <input className="input" type="email" value={signInEmail} onChange={e => setSignInEmail(e.target.value)} />
            </label>
            <label className="label">
              Password:
              <input className="input" type="password" value={signInPassword} onChange={e => setSignInPassword(e.target.value)} />
            </label>
            <input className="input" type="submit" value="Sign In" />
          </form>
        </>
      )}
      {showPayment && <PaymentForm onSuccess={handlePaymentSuccess}/>}
    </div>
  );
}

function PaymentForm({ onSuccess }) {
  const [cardName, setCardName] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiry, setExpiry] = useState('');
  const [cvv, setCvv] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();

    const cardDetails = {
      name: cardName,
      number: cardNumber,
      expiry: expiry,
      cvv: cvv,
    };

    // Create a Stripe token using the card details
    const stripe = await stripePromise;
    const response = await fetch('/create-payment-token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cardDetails),
    });
    const { token } = await response.json();

    // Use the token to process the payment
    const result = await stripe.confirmCardPayment(token, {
      payment_method: {
        card: {
          name: cardName,
        },
      },
    });

    if (result.error) {
      console.error(result.error);
      // Handle the error case
    } else {
      // Payment successful, show success message
      console.log('Payment successful!');
      // Add logic to handle the successful payment case
      onSuccess();
    }
  };

  return (
    <div className="payment-form-container">
      <h2>Become a Member</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Cardholder Name:</label>
          <input
            type="text"
            value={cardName}
            onChange={(e) => setCardName(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Card Number:</label>
          <input
            type="text"
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Expiry:</label>
          <input
            type="text"
            value={expiry}
            onChange={(e) => setExpiry(e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>CVV:</label>
          <input
            type="text"
            value={cvv}
            onChange={(e) => setCvv(e.target.value)}
          />
        </div>
        <button type="submit">Pay For Membership</button>
      </form>
    </div>
  );
}

export default Membership;
